import instance from "./interceptor";
import { Message, Loading } from "element-ui";
import Vue from "vue";
import store from "@/store";
import AES from "@/mixins/AES";
import { environment } from "@/plugins/environment"; // 引入环境变量

/**
 * 核心函数，可通过它处理一切请求数据，并做横向扩展
 * @param {url} 请求地址
 * @param {params} 请求参数
 * @param {options} 请求配置，针对当前本次请求；
 * @param loading 是否显示loading
 */

let loadingInstance = null;
let needLoadingRequestCount = 0;

function startLoading() {
  loadingInstance = Loading.service({
    target: "#main",
    spinner: "",
    text: "加载中",
    background: "rgba(0, 0, 0, 0.6)",
    customClass: "custom-loading",
  });

  loadingInstance.$el.style.zIndex = "10000";

  // 替换loading图片
  const baseImgUrl =
    environment == "estp"
      ? require("@/assets/images/loading.gif")
      : require("@/assets/images/normal-loading.gif");
  const spinnerEl = loadingInstance.$el.querySelector(".el-loading-spinner");
  if (spinnerEl) {
    // 1. 创建图片元素并清空src触发重绘
    spinnerEl.innerHTML = `<img id="global-loading-gif" style="width: 60px; height: 60px; margin-bottom: 10px;">`;
    const imgElement = spinnerEl.querySelector("#global-loading-gif");
    imgElement.src = baseImgUrl;
  }
}
function endLoading() {
  loadingInstance.close();
}
function showFullScreenLoading() {
  if (needLoadingRequestCount === 0) {
    startLoading();
  }
  needLoadingRequestCount++;
}
function tryHideFullScreenLoading() {
  if (needLoadingRequestCount <= 0) return;
  needLoadingRequestCount--;
  if (needLoadingRequestCount === 0) {
    endLoading();
  }
}

function request(
  url,
  params,
  options = { loading: true },
  headers,
  method,
  autoMessage = true
) {
  // let loadingInstance;
  // 请求前loading
  if (options.loading) {
    showFullScreenLoading();
    // 引入loading图片
    // const baseImgUrl = require("@/assets/images/loading.gif");

    // loadingInstance = Loading.service({
    //   target: "#main",
    //   spinner: "",
    //   text: "加载中",
    //   background: "rgba(0, 0, 0, 0.6)",
    //   customClass: "custom-loading",
    // });

    // loadingInstance.$el.style.zIndex = "10000";

    // // 替换loading图片
    // const spinnerEl = loadingInstance.$el.querySelector(".el-loading-spinner");
    // if (spinnerEl) {
    //   // 1. 创建图片元素并清空src触发重绘
    //   spinnerEl.innerHTML = `<img id="global-loading-gif" style="width: 60px; height: 60px; margin-bottom: 10px;">`;
    //   const imgElement = spinnerEl.querySelector("#global-loading-gif");
    //   imgElement.src = baseImgUrl;
    // }
  }

  return new Promise((resolve, reject) => {
    let data = {};
    const currentDate = new Date();
    const year = currentDate.getFullYear();
    const month = ("0" + (currentDate.getMonth() + 1)).slice(-2);
    const day = ("0" + currentDate.getDate()).slice(-2);
    const hours = ("0" + currentDate.getHours()).slice(-2);
    const minutes = ("0" + currentDate.getMinutes()).slice(-2);
    const seconds = ("0" + currentDate.getSeconds()).slice(-2);
    const milliseconds = ("00" + currentDate.getMilliseconds()).slice(-3); // 获取毫秒并保证始终占据3位数字
    const formattedDate = `${year}-${month}-${day} ${hours}:${minutes}:${seconds}.${milliseconds}`;
    headers = headers || {
      "Content-Type": "application/json,charset=UTF-8",
      "Access-Control-Allow-Origin": "*",
      "X-Request-Date": formattedDate,
    };
    // get请求使用params字段
    if (method == "get") data = { params };
    // post请求使用data字段
    if (method == "post") {
      data = { data: params };
    }
    instance({
      url,
      method,
      headers,
      ...data,
    })
      .then((res) => {
        // 此处作用很大，可以扩展很多功能。
        // 比如对接多个后台，数据结构不一致，可做接口适配器
        // 也可对返回日期/金额/数字等统一做集中处理
        if ("stack" in res) {
          console.log(res);
          reject(res);
          delete res.stack;
          delete res.config;
        } else {
          if (res.code == 200 || res.Code == 200 || !autoMessage) {
            resolve(res);
          } else if (res.code === 401) {
            Vue.prototype
              .$confirm(
                "无效的授权信息或授权信息已过期，请重新登录！",
                "系统通知",
                {
                  confirmButtonText: "跳转登录页面",
                  showCancelButton: false,
                  showClose: false,
                  closeOnClickModal: false, //取消点击遮罩关闭 MessageBox
                  closeOnPressEscape: false, //取消 ESC 键关闭 MessageBox
                  customClass: "confirm",
                  type: "error",
                }
              )
              .then(() => {
                store.dispatch("outLogin");
                if (
                  window.localStorage.getItem("server") === "managementSide"
                ) {
                  window.location.replace("/login/admin");
                } else {
                  window.location.replace("/login");
                }
              });
          } else {
            if (res.msg.length >= 500) {
              Message.error({
                customClass: "err-message-box",
                dangerouslyUseHTMLString: true,
                message: `<div style="max-height: 500px; overflow: auto;">${res.msg}</div>`,
                showClose: true,
                duration: 0,
              });
            } else {
              Message.error(res.msg);
            }
            reject(res);
          }
        }
      })
      .catch((error) => {
        console.log(error);
        reject(error);
        Message.error(error.msg);
      })
      .finally((error) => {
        reject(error);
        if (loadingInstance && options.loading) {
          // loadingInstance.close();
          tryHideFullScreenLoading();
        }
      });
  });
}

//封装get请求
function get(url, params, options) {
  return request(url, params, { loading: false }, options, "get");
}
//封装POST请求
function post(url, params, options, header, autoMessage, passFrequent) {
  let requestTime = window.localStorage.getItem("requestTime");
  if (!window.localStorage.getItem("requestURL")) {
    try {
      window.localStorage.setItem(
        "requestURL",
        AES.encrypt(JSON.stringify(url))
      );
      window.localStorage.setItem(
        "requestParams",
        AES.encrypt(JSON.stringify(params))
      );
    } catch (e) {
      console.error("请求参数过大，无法存储到localStorage:", e);
      // 清除可能的不完整存储
      window.localStorage.removeItem("requestURL");
      window.localStorage.removeItem("requestParams");
    }
  }
  let requestParams = "";
  if (typeof params === "object") {
    requestParams = JSON.stringify(params);
  } else if (params === undefined) {
    requestParams = String(params);
  } else {
    requestParams = params;
  }
  if (
    JSON.parse(AES.decrypt(window.localStorage.getItem("requestURL"))) ===
      url &&
    AES.decrypt(window.localStorage.getItem("requestParams")) ==
      requestParams &&
    requestTime === "false" &&
    !passFrequent
  ) {
    return new Promise((resolve, reject) => {
      console.log("操作过于频繁，请稍后再试！");
      console.log(requestParams, url);

      reject("操作过于频繁，请稍后再试！");
    });
  } else {
    window.localStorage.removeItem("requestTime");
    window.localStorage.setItem("requestTime", false);
    window.localStorage.setItem("requestURL", AES.encrypt(JSON.stringify(url)));
    try {
      window.localStorage.setItem(
        "requestURL",
        AES.encrypt(JSON.stringify(url))
      );
      if (typeof params === "object") {
        window.localStorage.setItem(
          "requestParams",
          AES.encrypt(JSON.stringify(params))
        );
      } else {
        window.localStorage.setItem("requestParams", AES.encrypt(params));
      }
    } catch (e) {
      console.error("请求参数过大，无法存储到localStorage:", e);
      window.localStorage.removeItem("requestURL");
      window.localStorage.removeItem("requestParams");
    }
  }
  setTimeout(() => {
    window.localStorage.removeItem("requestTime");
    window.localStorage.setItem("requestTime", true);
  }, 300);
  return request(url, params, options, header, "post", autoMessage);
}
//封装Upload请求
function upload(url, data, options) {
  // let loadingInstance;
  // 请求前loading
  if (options.loading) {
    showFullScreenLoading();
    // loadingInstance = Loading.service({
    //   target: "#main",
    //   spinner: "el-icon-loading",
    //   text: "加载中",
    //   background: "rgba(0, 0, 0, 0.6)",
    // });
  }

  return new Promise((resolve, reject) => {
    instance({
      url,
      method: "post",
      headers: {
        "Content-type": "multipart/form-data",
        "Access-Control-Allow-Origin": "*",
      },
      data,
    })
      .then((res) => {
        // 此处作用很大，可以扩展很多功能。
        // 比如对接多个后台，数据结构不一致，可做接口适配器
        // 也可对返回日期/金额/数字等统一做集中处理
        if (res.code == 200 || res.Code == 200) {
          resolve(res);
        } else {
          if (res.msg.length >= 500) {
            Message.error({
              customClass: "err-message-box",
              dangerouslyUseHTMLString: true,
              message: `<div style="max-height: 500px; overflow: auto;">${res.msg}</div>`,
              showClose: true,
              duration: 0,
            });
          } else {
            Message.error(res.msg);
          }
          reject(res);
        }
      })
      .catch((error) => {
        console.log(error);
        reject(error);
        Message.error(error.msg);
      })
      .finally((error) => {
        console.log(error);
        reject(error);
        if (loadingInstance) {
          loadingInstance.close();
          tryHideFullScreenLoading();
        }
      });
  });
}
export default {
  get,
  post,
  upload,
};
